<template>
  <!-- 已登陆 -->
  <el-button
    v-if="currentUser && currentUser.id"
    :title="JSON.stringify(currentUser) + ' 点我干啥呢? 切换用户? 重新登陆?'"
    plain
    style="width:100%;"
    @click="goLogin">#{{currentUser.id}} {{currentUser.name}}({{currentUser.loginName}},{{currentUser.phone}}) 已登陆</el-button>

  <!-- 未登陆 -->
  <el-button
    v-else
    title="点我干啥呢? 切换用户? 重新登陆?"
    plain
    style="width:100%;"
    @click="goLogin">{{'new' != this.dataMode ? '未登陆' : '点我去登陆'}}</el-button>
</template>

<script>
export default {
    name : 'TicketFormAuth',

    props : ['value', 'item'],

    data() {
      return {
        dataMode : '',
        currentUser : {}
      }
    },

    watch: {
      value(after, before) {
        console.log('#31 TicketFormAuth watch value', after, before, this);

        this.loadUserById(this.value);
      }
    },

    methods : {
      loadUserById( _id ) {
        if ( 'detail' != this.dataMode ) { // 传入用户ID,仅在详情页生效,新建页获取当前用户
          console.log('#35 loadUserById, watch value up', this);
          return;
        }

        var _this = this;

        sdk.TicketUserApi().findById({
          id : _id
        }).then(res => {
          _this.currentUser = res;
        });
      },

      loadCurrentUser() {
        if ( 'new' != this.dataMode ) {
          console.log('#35 loadCurrentUser return', this);
          return; // 详情页不加载当前用户 新建页才做
        }

        var _this = this;

        sdk.TicketUserApi().currentUserCached().then(res => {
            if ( !res ) {
              console.log('#27 currentUserCached', res);
              return;
            }

            _this.currentUser = res;

            _this.$emit('input', res.id);
            _this.$emit('change', res.id);
        }, err => {
          console.log('#69 currentUserCached error', err);
        });
      },

      goLogin() {
        if ( 'new' != this.dataMode ) {
          return; // 新建页才做
        }

        localStorage.setItem('ticket.UrlBeforeLogin.href', location.href); // 登陆前地址

        location.href = "/ticket/sso/authorize?16"; // 去登陆
      }
    },

    mounted() {
      this.dataMode = '/ticket-vue/ticket/detail' == this.$route.path ? 'detail' : 'new';

      this.loadCurrentUser();
    }
}
</script>



// WEBPACK FOOTER //
// src/components/ticket/TicketFormAuth.vue